import {
  KoNotificationDTO,
  LoanCaseEventDTO,
  LoanCaseStatusDTOStatusEnum,
} from "@smartx/mikro-vt-client-api"

export const getPalAnnualRevisionKoNotifications = (
  status: string | undefined,
  caseId: string | undefined,
  caseEvents: LoanCaseEventDTO[] | undefined,
): KoNotificationDTO[] | undefined => {
  if (status !== LoanCaseStatusDTOStatusEnum.PalAnnualRevision || !caseId) {
    return undefined
  }

  const event = caseEvents?.find(
    (e) => e.caseId === caseId && !!e.koNotifications?.length,
  )

  return event?.koNotifications
}
